import React, { useState, useEffect } from 'react';
import './Testimonials.css';

// --- Icons ---
const ChevronLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);
const ChevronRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18l6-6-6-6" />
  </svg>
);
const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const TESTIMONIALS_DATA = [
  {
    id: "BRIJESH-2009",
    name: "Mr. Brijesh Sah",
    role: "Senior Manager @ Sun Pharma",
    image: "./Testimonials/imgi_35_t1751259689_6kQPvDoctn.jpg",
    quote: "TIMSCDR had been a great contributor towards the development of my career. The entire staff was very supportive and approachable with an attitude of being ever ready to help. Class room trainings along with real-time case studies, industry best practices with examples and improving communication skills with",
    tags: ["#SunPharma", "#CareerGrowth", "#ProfessionalGrowth"]
  },
  {
    id: "RAJIV-2011",
    name: "Mr. Rajiv Singh",
    role: "Head of Technology @ Play Time Media (I) Pvt. Ltd.",
    image: "./Testimonials/imgi_36_t1751018041_uNidg7kYxH.jpg",
    quote: "TIMSCDR is one of the important base in my life. I owe my current career and progress to this esteemed institution which played an active role in shaping my personality. It provides the necessary freedom to explore your interest along with studies. A practical approach towards life and work is what I gained through",
    tags: ["#Leadership", "#Technology", "#PracticalLearning"]
  },
  {
    id: "ROIDON-2016",
    name: "Mr. Roidon Rodrigues",
    role: "Senior Test Automation Engineer @ Farmlands",
    image: "./Testimonials/imgi_37_t1751017967_oVgR3JmJsS.jpg",
    quote: "TIMSCDR's three years gave me ample of opportunities where I was able to grow and develop my skills. These skills were not only academic based but also skills required to have a successful career. I had participated in the tech fest as a core committee member and during that time I was exposed to a leadership role which I",
    tags: ["#QA", "#Automation", "#Leadership"]
  },
  {
    id: "MUZAMMIL-2017",
    name: "Mr. Muzammil Jafferi",
    role: "Software Engineer @ Coolbet",
    image: "./Testimonials/imgi_38_t1751017884_wD44rLceEJ.jpg",
    quote: "I am thankful to all my Teachers of TIMSCDR whose support were like parents in all the situation throughout my MCA career. Taking admission in TIMSCDR was a perfect decision for me. TIMSCDR provides a great platform for learning and has helped me to develop a positive attitude towards my life & decision-making",
    tags: ["#SoftwareEngineer", "#DecisionMaking"]
  },
  {
    id: "RISHABH-NEW",
    name: "Mr. Rishabh Singh",
    role: "Java Consultant, Deloitte USI",
    image: "./Testimonials/imgi_15_t1783761851_7sCf6YzXpS.jpg",
    quote: "I am grateful to have been a part of Thakur Institute of Management Studies, Career Development & Research. The institute provided excellent faculty support, practical learning opportunities, and a positive environment that encouraged innovative thinking and creativity among students. The curriculum.",
    tags: ["#Java", "#Deloitte", "#Consulting"]
  },
  {
    id: "MAYURI-2021",
    name: "Ms. Mayuri Tiwari",
    role: "Senior Software Engineer @ 3Pillar Global",
    image: "./Testimonials/imgi_16_t1751018180_zQ8oO2L8hG.jpg",
    quote: "Thank you for shaping me into the adult that I am today and for giving me professors that truly cared about my success and didn't see me as a number. Thank you for providing me with lifelong mentors who I know I could always go to at any point in my career. Thank you for opening doors to so many opportunities and thank you",
    tags: ["#SoftwareEngineer", "#Mentorship", "#CareerGrowth"]
  },
  {
    id: "RAHUL-2022",
    name: "Mr. Rahul Gupta",
    role: "Senior Development Engineer @ Razorpay",
    image: "./Testimonials/imgi_41_t1751018363_7kFJnpqHGV.jpg",
    quote: "I would like to express my sincere gratitude to TIMSCDR for helping me at each and every step of my professional career. The Institute provided me the best possible platform and infrastructure to pursue my career interest. The. expert faculty made me industry ready. while the placement training helped me enhance",
    tags: ["#SDE", "#Razorpay", "#IndustryReady"]
  },
  {
    id: "ASHISH-2022",
    name: "Mr. Ashish Jaiswal",
    role: "Team Lead @ TCS",
    image: "./Testimonials/imgi_42_t1751018254_CNs6m6rrpa.jpg",
    quote: "At TIMSCDR, I realised a well-known proverb by 'Chris Grosser', \"Opportunities don't happen, You create them\". At TIMSCDR, we are offered numerous opportunities to learn well as to earn. It's up-to you to extract the most out of them. At TIMSCDR, I got the opportunity to participate in several competitions",
    tags: ["#TCS", "#TeamLead", "#Competitions"]
  },
  {
    id: "EBRAHIM-NEW",
    name: "Mr. Ebrahim Mondal",
    role: "Senior Associate Technical Support Delivery Analyst, Workday",
    image: "./Testimonials/imgi_43_t1783762445_xgwnA8zwcG.jpg",
    quote: "I had a very good learning experience at the institute. The curriculum was well-structured and covered both theoretical and practical concepts, which helped me improve my technical knowledge and coding skills. The faculty members were very supportive, patient, and",
    tags: ["#Workday", "#TechnicalSupport", "#CodingSkills"]
  },
  {
    id: "SAIFULLAH-NEW",
    name: "Mr. Saifullah Khan",
    role: "Senior Business Analyst, Winjit Technologies Pvt Ltd.",
    image: "./Testimonials/imgi_44_t1783762014_JKYQVwZiqA.jpg",
    quote: "My journey at Thakur Institute of Technology played a key role in shaping both my technical knowledge and professional confidence. The practical learning approach, supportive faculty and project-based exposure helped me develop strong analytical and problem-solving skills. The experience here prepared",
    tags: ["#BusinessAnalyst", "#Winjit", "#ProblemSolving"]
  },
  {
    id: "UZMA-2022",
    name: "Ms. Uzma Khan",
    role: "Software Engineer @ Capgemini",
    image: "./Testimonials/imgi_21_t1751018416_h8b10EIGj6.jpg",
    quote: "I would like to appreciate TIMSCDR for helping me in each step of my master's career, and especially pleased to have the opportunity to share some of my thoughts and observations about our college. These past few months have acted as a stepping stone for us in understanding how to achieve our goals during this",
    tags: ["#Capgemini", "#SoftwareEngineer", "#PlacementSupport"]
  },
  {
    id: "ROBERT-NEW",
    name: "Mr. Robert Kennedy",
    role: "AEM Consultant, Decision Culture",
    image: "./Testimonials/imgi_46_t1783762220_UQbggPcElR.jpg",
    quote: "The MCA course enhanced my technical knowledge, programming skills, and problem-solving abilities. The combination of theory and practical learning helped me gain confidence and prepare for a career in the IT industry.",
    tags: ["#AEM", "#Consultant", "#MCA"]
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const current = TESTIMONIALS_DATA[currentIndex];

  // Typewriter Logic
  useEffect(() => {
    let index = 0;
    setIsTyping(true);
    setDisplayText(''); // Reset text on change

    const intervalId = setInterval(() => {
      setDisplayText(current.quote.slice(0, index));
      index++;

      if (index > current.quote.length) {
        clearInterval(intervalId);
        setIsTyping(false);
      }
    }, 25); // Speed of typing

    return () => clearInterval(intervalId);
  }, [currentIndex, current.quote]);

  const nextSlide = () => setCurrentIndex((prev) => (prev === TESTIMONIALS_DATA.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? TESTIMONIALS_DATA.length - 1 : prev - 1));

  return (
    <div className="ta-page-wrapper">
      <div className="ta-isometric-overlay"></div>
      <div className="ta-main-content">
        <div className="ta-header">
          <div className="rs5865f2-titleWrap">
            <div className="rs5865f2-titleRow">
              <div className="rs5865f2-titlePlain">Our</div>
              <div className="rs5865f2-titleGradient">Testimonials</div>
            </div>
            <div className="rs5865f2-gradientLine" />
          </div>
          {/* <div className="ta-subtitle">// Stream: Encrypted_Data_Package...</div> */}
        </div>

        <div className="ta-terminal-container">
          <button className="ta-nav-btn ta-nav-prev" onClick={prevSlide}><ChevronLeft /></button>
          <button className="ta-nav-btn ta-nav-next" onClick={nextSlide}><ChevronRight /></button>

          <div className="ta-terminal-window">
            <div className="ta-scan-line"></div>
            <div className="ta-terminal-header">
              <div className="ta-header-left">
                <div className="ta-dot ta-dot-red"></div>
                <div className="ta-dot ta-dot-yellow"></div>
                <div className="ta-dot ta-dot-green"></div>
                <div className="ta-filename">system/logs/user_{current.id}.env</div>
              </div>
              <div className="ta-header-right"><SearchIcon /><SettingsIcon /></div>
            </div>

            <div className="ta-terminal-body">
              <div className="ta-line-numbers">
                01<br />02<br />03<br />04<br />05<br />06<br />07<br />08<br />09<br />10<br />11
              </div>

              <div className="ta-content-area">
                <div className="ta-profile-section">
                  <div className="ta-image-frame">
                    <img src={current.image} alt={current.name} />
                  </div>
                  <div className="ta-meta">
                    <div className="ta-role">{current.role}</div>
                    {/* Update the line below */}
                    <div className="ta-uuid">Batch: {current.id.split('-')[1]}</div>  </div>
                </div>

                <div className="ta-text-section">
                  <div className="ta-user-info">
                    <div className="ta-user-name">
                      {current.name} <span className="ta-method">.fetch()</span>
                    </div>
                    <div className="ta-accent-bar"></div>
                  </div>

                  <div className="ta-quote">
                    <span className="ta-quote-mark">"</span>
                    {displayText}
                    {isTyping && <span className="ta-cursor">|</span>}
                    <span className="ta-quote-mark">"</span>
                  </div>

                  <div className="ta-tags">
                    {current.tags.map((tag, i) => (
                      <span key={i} className="ta-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ta-explore-section">
          <div className="ta-explore-title">REMOTE NODES</div>
          <div className="ta-explore-divider"></div>
          <div className="ta-thumbnail-grid">
            {TESTIMONIALS_DATA.map((item, index) => (
              <div
                key={item.id}
                className={`ta-thumb-wrapper ${index === currentIndex ? 'ta-thumb-active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              >
                <div className={`ta-thumb-image ${index !== currentIndex ? 'ta-inactive' : ''}`}>
                  <img src={item.image} alt={item.name} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ta-status-bar">
          <div className="ta-status-item"><div className="ta-status-led"></div> SYNC_COMPLETE</div>
          <div className="ta-divider">|</div>
          <div className="ta-status-item">LOAD: {current.quote.length}bps</div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;